<script setup>
import { computed } from 'vue'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

import { Bar } from 'vue-chartjs'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
)

const props = defineProps({
  chartData: { type: Object, required: true },
  options:   { type: Object, default: () => ({}) }
})

// Estil fosc per defecte
const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      enabled: true,
      backgroundColor: '#0e151c',
      borderColor: '#08c0e6',
      borderWidth: 1,
      titleColor: '#e6edf3',
      bodyColor: '#e6edf3',
      displayColors: false
    }
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: '#c9d1d9', font: { weight: 700 } }
    },
    y: {
      beginAtZero: true,
      grid: { color: '#8696a733', drawTicks: false },
      border: { display: false },
      ticks: { color: '#c9d1d9', font: { weight: 700 } }
    }
  }
}

const optionsWithDefaults = computed(() => ({
  ...defaultOptions,
  ...(props.options || {})
}))
</script>

<template>
  <Bar :data="chartData" :options="optionsWithDefaults" />
</template>
